import { CATEGORIES, isDeviceKind } from "@dransay/api/models";
import type { TFunction } from "i18next";

export const getAmountInCartLabel = (
	t: TFunction,
	amount: number,
	category: string | null,
	kind?: string | null,
) => {
	if (category === CATEGORIES.INHALATIONS_EXTRACT && isDeviceKind(kind)) {
		return t("nPieces", { amount });
	}

	switch (category) {
		case CATEGORIES.FLOWERS:
			return t("nGrams", { amount });
		case CATEGORIES.EXTRACTS:
			return t("nMilliliters", { amount });
		case CATEGORIES.INHALATIONS_EXTRACT:
			return t("nMilliliters", { amount });
		case CATEGORIES.EDIBLES:
			return t("nPieces", { amount });
		case CATEGORIES.DRINKABLES:
			return t("nPieces", { amount });
		case CATEGORIES.CAPSULES:
		case CATEGORIES.CANNABIS_ACCESSORIES:
			return t("nPieces", { amount });
		default:
			return "";
	}
};
